import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DATASET_TYPES_OBSERVATION_IDS, DatasetTypeEnum } from '../../../../shared/dataset/model/dataset-type.enum';
import { DatasetService } from '../../../../shared/dataset/service/dataset.service';
import { StudyEditorContext } from '../../../study-editor.context';
import { DatasetModel } from '../../../../shared/dataset/model/dataset.model';

@Component({
    selector: 'jhi-choose-dataset-modal',
    templateUrl: './choose-dataset-modal.component.html',
    styleUrl: './choose-dataset-modal.component.scss'
})
export class ChooseDatasetModalComponent implements OnInit {

    title: string;
    description: string;
    titleKey: string;
    descriptionKey: string;
    hideObservation: boolean;
    supportedDatasetTypes: DatasetTypeEnum[];
    selectedDatasetType: DatasetModel;
    datasetTypes: any[];
    datasetTypeMap = {};
    datasets: DatasetModel[];


    constructor(private activeModal: NgbActiveModal,
                private translateService: TranslateService,
                private datasetService: DatasetService,
                private studyEditorContext: StudyEditorContext) {

        this.datasetTypes = [{
            id: DatasetTypeEnum.PLANT_SUBOBSERVATIONS,
            tabTitlePrefix: 'Plants: ',
            tabNamePrefix: 'study-editor.dataset.label-plants'
        }, {
            id: DatasetTypeEnum.QUADRAT_SUBOBSERVATIONS,
            tabTitlePrefix: 'Quadrats: ',
            tabNamePrefix: 'study-editor.dataset.label-quadrats'
        }, {
            id: DatasetTypeEnum.TIME_SERIES_SUBOBSERVATIONS,
            tabTitlePrefix: 'Time Series: ',
            tabNamePrefix: 'study-editor.dataset.label-time-series'
        }, {
            id: DatasetTypeEnum.CUSTOM_SUBOBSERVATIONS,
            tabTitlePrefix: 'Sub-Observation Units: ',
            tabNamePrefix: 'study-editor.dataset.label-custom'
        }, {
            id: DatasetTypeEnum.PLOT,
            tabTitlePrefix: '',
            tabNamePrefix: 'study-editor.dataset.label-plots'
        }];

        this.datasetTypes.forEach((datasetType) => {
            this.datasetTypeMap[datasetType.id] = datasetType;
        });
    }

    ngOnInit(): void {
        if (this.titleKey) {
            this.title = this.translateService.instant(this.titleKey);
        }
        if (this.descriptionKey) {
            this.description = this.translateService.instant(this.descriptionKey);
        }
        const studyId = this.studyEditorContext.studyDetails.id;
        const datasetTypes = (this.supportedDatasetTypes && this.supportedDatasetTypes.length > 0) ? this.supportedDatasetTypes : DATASET_TYPES_OBSERVATION_IDS;
        this.datasetService.getDatasetsWithoutMetadata(studyId, datasetTypes).toPromise().then((response) => {
            const datasets = response.body;
            if (this.hideObservation) {
                this.datasets = datasets.slice(1);
            } else {
                this.datasets = datasets;
            }
            const currentDataset = this.datasets.find((dataset) => dataset.datasetId === this.studyEditorContext?.currentDataset?.datasetId);
            if (currentDataset) {
                this.selectedDatasetType = currentDataset;
            } else {
                this.selectedDatasetType = this.datasets[0];
            }
        });
    }

    dismiss() {
        this.activeModal.dismiss();
    }

    continue() {
        this.activeModal.close(this.selectedDatasetType);
    }

    getDatasetType(datasetTypeId: any) {
        return this.datasetTypeMap[datasetTypeId];
    }

    compareByDatasetId(o1, o2) {
        return o1.datasetId === o2.datasetId;
    }
}
